module.exports = __webpack_public_path__ + "media/sub7-3-2.486cf078.mp4";